import React from 'react';
import { Container } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import Button from '../Button';
import { Phone } from './PhoneForm';
import PhoneFormModal from './PhoneFormModal';

const testPhone: Phone = {
  type: 'home',
  phone: '(444) 444-4444',
  messaging: 'false',
};

const EmailFormDemo = () => {
  const [showModal, handleShow, handleClose] = useModal();

  const [phone] = React.useState<Phone>(testPhone);

  const handleSubmit = () => {
    console.log('submit', phone);
    handleClose();
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Phone Form Modal</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center p-0">
          <Button variant="primary" onMouseDown={handleShow}>
            Add Phone
          </Button>
          <PhoneFormModal
            showModal={showModal}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
          />
        </Container>
      </Container>
    </Container>
  );
};

export default EmailFormDemo;
